var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBadge3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM13.5085 9.91459C13.5718 10.0651 13.7075 10.1684 13.8638 10.1848L16.6073 10.4731C16.9845 10.5127 17.1367 11.0029 16.8538 11.2671L14.7961 13.1883C14.6789 13.2978 14.6271 13.4648 14.6604 13.6255L15.2463 16.4458C15.3268 16.8336 14.9285 17.1366 14.601 16.9366L12.2196 15.4818C12.0839 15.399 11.9161 15.399 11.7804 15.4818L9.39899 16.9366C9.07154 17.1366 8.67318 16.8336 8.75373 16.4458L9.33956 13.6255C9.37293 13.4648 9.32108 13.2978 9.20386 13.1884L7.14622 11.2671C6.86329 11.0029 7.01545 10.5127 7.39268 10.4731L10.1362 10.1848C10.2925 10.1684 10.4282 10.0651 10.4915 9.91459L11.6012 7.27247C11.7538 6.90918 12.2462 6.90918 12.3988 7.27247L13.5085 9.91459Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadge3);
export default __webpack_public_path__ + "static/media/badge-3.54cec403e523817d69d5e5145d79bea9.svg";
export { ForwardRef as ReactComponent };